/**
 * Compare matrix detail formatters (compare page expanded specs).
 * Row shape is built from Supabase `product_specs` in `CompareScreensV2Compare`.
 */

/** Same for all v2 picks: short, accurate for Panoptix / LiveScope support. */
export const COMPARE_V2_LIVESCOPE_SUMMARY =
  'Yes · compatible Panoptix™ / LiveScope™ transducer required';

export function formatCompareDetailControls(screenRow) {
  if (!screenRow) return '-';
  if (screenRow.controlMethod === 'Keypad') return 'Keypad + touchscreen';
  return 'Touchscreen';
}

/** NMEA + Garmin Marine Network count, scannable (use with white-space: pre-line). */
export function formatCompareDetailPorts(screenRow) {
  if (!screenRow) return '-';
  const n = screenRow.networkPorts ?? '?';
  return `NMEA 2000\n${n}× Garmin Marine Network`;
}

export function formatCompareDetailVideo(screenRow) {
  if (!screenRow) return '-';
  const parts = [];
  if (screenRow.hdmiOut === 'Yes') parts.push('HDMI out');
  if (screenRow.hdmiIn === 'Yes') parts.push('HDMI in');
  if (screenRow.bncVideoIn === 'Yes') parts.push('BNC composite in');
  if (parts.length === 0) return 'No HDMI out';
  return parts.join(' · ');
}
